import { SelectButton } from './SelectButton'

export const ConnectedSelectButton = SelectButton

export { ConnectedSelectButton as SelectButton }
